import {createContext, useCallback, useContext, useMemo, useState} from "react";

const FormContext = createContext(null);

export const useFormContext = () => {
    return useContext(FormContext);
};

const useForm = (initialState) => {
    const [values, setValues] = useState(initialState);
    const get = useCallback((key) => values[key], [values]);
    const set = useCallback((key, val) => {
        setValues((values) => {
            const newValue = typeof val === 'function' ? val(values[key]) : val;
            return {...values, [key]: newValue};
        });
    }, [setValues]);
    const context = useMemo(() => ({get, set}), [get, set]);
    const Provider = useMemo(() => ({children}) => (
        <FormContext.Provider value={context}>
            {children}
        </FormContext.Provider>
    ), [context]);
    return [values, Provider];
};

export default useForm;
